export const MAX_REFERENCE_FILE_SIZE = 50 * 1024 * 1024

export const CREATIVE_GUIDELINE_SECTION_LABELS = Object.freeze({
  vision: 'Vision',
  characters: 'Characters',
  outfits: 'Outfits',
  locations: 'Locations',
  storyboard: 'Storyboard',
  finalized: 'Creative Guideline'
})

export const starterPrompts = [
  {
    key: 'suggest',
    icon: 'star',
    title: 'Suggest for me',
    description: 'AI reads the story and suggests a vision.',
    actionLabel: 'Start',
    recommended: true,
    message:
      'Read my story and suggest a clear visual direction before we generate the shot list.'
  },
  {
    key: 'questions',
    icon: 'question-circle',
    title: 'Ask me questions',
    description: 'AI asks guided questions to shape the look.',
    actionLabel: 'Start',
    action: 'start'
  },
  {
    key: 'known-style',
    icon: 'edit',
    title: 'I know the style',
    description: 'Tell the AI your style and references.',
    actionLabel: 'Start',
    message:
      'I already have a visual style in mind. Ask me only the key questions needed before the shot list.'
  }
]

export const PHASE_VIEWS = {
  vision: {
    label: CREATIVE_GUIDELINE_SECTION_LABELS.vision,
    navLabel: CREATIVE_GUIDELINE_SECTION_LABELS.vision,
    shortLabel: CREATIVE_GUIDELINE_SECTION_LABELS.vision,
    icon: 'file-text',
    title: CREATIVE_GUIDELINE_SECTION_LABELS.vision,
    description: 'Chat with the AI and save the visual vision.',
    primaryNoun: 'vision',
    tip: 'Save the vision when it is clear enough to guide the next steps.'
  },
  characters: {
    label: CREATIVE_GUIDELINE_SECTION_LABELS.characters,
    navLabel: CREATIVE_GUIDELINE_SECTION_LABELS.characters,
    shortLabel: CREATIVE_GUIDELINE_SECTION_LABELS.characters,
    icon: 'team',
    title: CREATIVE_GUIDELINE_SECTION_LABELS.characters,
    description: 'Extract, review, and generate the characters in the story.',
    primaryNoun: 'characters',
    generatedLabel: 'character assets',
    tip: 'Characters may require approval before the next phase opens.'
  },
  outfits: {
    label: CREATIVE_GUIDELINE_SECTION_LABELS.outfits,
    navLabel: CREATIVE_GUIDELINE_SECTION_LABELS.outfits,
    shortLabel: CREATIVE_GUIDELINE_SECTION_LABELS.outfits,
    icon: 'skin',
    title: CREATIVE_GUIDELINE_SECTION_LABELS.outfits,
    description: 'Create outfit sheets and visual continuity for the characters.',
    primaryNoun: 'outfits',
    generatedLabel: 'outfit sheets',
    tip: 'Generate outfit sheets before moving into locations.'
  },
  locations: {
    label: CREATIVE_GUIDELINE_SECTION_LABELS.locations,
    navLabel: CREATIVE_GUIDELINE_SECTION_LABELS.locations,
    shortLabel: CREATIVE_GUIDELINE_SECTION_LABELS.locations,
    icon: 'global',
    title: CREATIVE_GUIDELINE_SECTION_LABELS.locations,
    description: 'Build the location boards for the film.',
    primaryNoun: 'locations',
    generatedLabel: 'location boards',
    tip: 'Location counts can include base locations and variants.'
  },
  storyboard: {
    label: CREATIVE_GUIDELINE_SECTION_LABELS.storyboard,
    navLabel: CREATIVE_GUIDELINE_SECTION_LABELS.storyboard,
    shortLabel: CREATIVE_GUIDELINE_SECTION_LABELS.storyboard,
    icon: 'layout',
    title: CREATIVE_GUIDELINE_SECTION_LABELS.storyboard,
    description: 'Discuss, lock, and generate storyboard sheets through chat.',
    primaryNoun: 'panels',
    generatedLabel: 'storyboard sheets',
    tip: 'Ask the AI to write the plan, revise it, lock it, and generate boards.'
  },
  finalized: {
    label: CREATIVE_GUIDELINE_SECTION_LABELS.finalized,
    navLabel: CREATIVE_GUIDELINE_SECTION_LABELS.finalized,
    shortLabel: CREATIVE_GUIDELINE_SECTION_LABELS.finalized,
    icon: 'book',
    title: CREATIVE_GUIDELINE_SECTION_LABELS.finalized,
    description: 'Finalize the creative guideline and unlock the shot list.',
    primaryNoun: 'guideline',
    generatedLabel: 'creative guideline',
    tip: 'The next step unlocks after the creative guideline is finalized.'
  }
}
